import controller from './featured-slider.controller';
import templateBase from './templates/featured-slider-base.view.html';
import templateAD from './templates/featured-slider-adaptative.html';

let FeaturedSliderComponent = {
    template: changeTemplate,
    controller,
    bindings: {
        shCtrl: '<',
        itemName: '@',
        type: '@',
        x:'@',
        itemData: '@',
        categoryId: '@',
        itemId: '@'
    }
};

function changeTemplate() {

    if (__env.adaptative) {
        return templateAD;
    } else {
        return templateBase;
    }
}

export default FeaturedSliderComponent;



/** WEBPACK FOOTER **
 ** ./www/components/home/featured-slider/featured-slider.component.js
 **/